import { render, staticRenderFns } from "./GoodwillCreditModal.vue?vue&type=template&id=10655688"
import script from "./GoodwillCreditModal.vue?vue&type=script&lang=js"
export * from "./GoodwillCreditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports